/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown>, name: NonNullable<unknown> }} Hero_Next_WithInputs */

const en_hero_next_with = /** @type {(inputs: Hero_Next_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min with ${i?.name}`)
};

const pl_hero_next_with = /** @type {(inputs: Hero_Next_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min u ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{minutes} min with {name}" |
*
* @param {Hero_Next_WithInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_next_with = /** @type {((inputs: Hero_Next_WithInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Next_WithInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_next_with(inputs)
	return en_hero_next_with(inputs)
});